"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Actions = void 0;

var tslib_1 = require("tslib");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Actions = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0.25rem;\n  right: 0.25rem;\n  gap: 0.25rem;\n\n  &:focus {\n    position: absolute;\n  }\n\n  &:focus-visible {\n    position: absolute;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  position: absolute;\n  top: 0.25rem;\n  right: 0.25rem;\n  gap: 0.25rem;\n\n  &:focus {\n    position: absolute;\n  }\n\n  &:focus-visible {\n    position: absolute;\n  }\n"])));
var templateObject_1;